<template>
  <el-color-picker
    v-model="fvalue"
    :size="size"
    :show-alpha="showAlpha"
    :disabled="disabledValue"
  ></el-color-picker>
</template>

<script>
const utils = require("@/api/core/utils");
export default {
  name: "yes-colorPicker",
  props: {
    titleCss: String,
    contentCss: String,
    definedCss: Object,
    dataSource: String,
    formCreateInject: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
    },
    showAlpha: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
  data () {
    return {
      fvalue: "",
      fDataSource: this.dataSource,
      disabledValue: false
    };
  },
  mounted () {
    this.disabledValue = this.disabled
    this.loadSourceData();
  },
  watch: {
    disabled(val){
      this.disabledValue = val
    },
    fvalue (val) {
      this.$emit("input", val);
      utils.noticeParentDataObject(this.formCreateInject, this.fvalue);
    },
  },
  methods: {
    setDisabled(val) {
      this.disabledValue = val
    },
    // 将组件的值返回
    getValue () {
      return this.fvalue;
    },
    // 修改组件的值
    setValue (val) {
      this.fvalue = val;
    },
    // 读取绑定数据源数据
    loadSourceData () {
      let val = utils.getSourceData(this.fDataSource);
      this.fvalue = val !== undefined ? val : this.fvalue;
      // this.fvalue = utils.getSourceData(this.fDataSource);
    },
    // 修改绑定数据源数据
    updateSourceData (val) {
      utils.updateSourceData(this.fDataSource, val);
    },
    change (val) {
      if (this.fDataSource) {
        this.updateSourceData(val);
      }
    },
  },
};
</script>